import React from 'react'
import get from 'lodash/get'

const string = ({row,name,keyValue = null}) => {

    const printValue = (value,key) => {

        if( ! value ) {
            return <div></div>
        }

        

        if( key ) {
            const _value = value[key]
            return <div>{typeof _value !== 'string' ? '' : _value}</div>
        } else {
            if( typeof value !== 'string' ) {
                return null
            }
            return <div>{value}</div>
        }
    }


    const value = get( row,  name === 'name' ? 'form.name' : name , null)

    if( Array.isArray( value ) ) {

        return value.map( v => {
            return printValue(v,keyValue)
        })

    } else {
        return printValue(value,keyValue)
    }
}

export default string